export default __webpack_public_path__ + "static/media/allocation.33d64791.png";